<template>
  <div class="about-container">
    <div class="about-section">
      <h2 class="about-heading">About Me</h2>
      <div class="about-details">
        <p>
          Hey there! My name's Josue, (pronounced ho-sway), but you can call me
          Omar. I'm a soon-to-be graduate from Tech Elevators Full-Stack Web
          Development program.
        </p>
        <p>
          I'm all about creating efficient and clean, user-friendly solutions
          and I love to collaborate with others to bring ideas to life. As a
          developer, I'm passionate about learning and growing to stay agile in
          an ever-changing digital world. I'm always eager to take on new
          challenges and tackle new technologies.
        </p>
        <!-- <p>
          Over the past year, I've built on my skills with front-end
          technologies like Vue.js and JavaScript. While on the back-end using
          PostgreSQL and Spring Boot among many others, learning how to build
          robust and scalable applications along the way.
        </p> -->
        <p>
          If you're looking for a developer that's dedicated to delivering
          high-quality work, please don't hesitate to get in touch via my
          <a
            href="https://www.linkedin.com/in/josue-o-tejada/"
            class="page-link"
            target="_blank"
            >LinkedIn</a
          >
          or
          <router-link to="/contact" class="page-link">contact form</router-link
          >, and feel free to browse my portfolio of projects in the meantime.
        </p>
        <p>Thanks for stopping by!</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutSection",
};
</script>

<style>
.about-section {
  color: white;
  width: auto;
  height: 90vh;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}

.page-link {
  color: white;
}

.about-details {
  width: 50%;
}

.about-details p {
  font-size: 1.5rem;
  letter-spacing: 0.5px;
  line-height: 2;
}

.about-heading {
  font-size: 3rem;
  margin-bottom: 4rem;
}

@media only screen and (max-width: 800px) {
  .about-details {
    margin-bottom: 3rem;
    overflow: scroll;
  }

  .about-heading {
    margin: 2.5em 0 1em 0;
  }
}

@media only screen and (max-width: 500px) {
  .about-section {
    height: fit-content;
  }
  .about-heading {
    font-size: 1.5rem;
    margin: 2em 0 1em 0;
  }

  .about-details p {
    font-size: 1rem;
    letter-spacing: 0.01em;
  }
}
</style>
